"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHAT_EVENT_ACTION;
(function (CHAT_EVENT_ACTION) {
    CHAT_EVENT_ACTION["chatEventMessageEdited"] = "chatEventMessageEdited";
    CHAT_EVENT_ACTION["chatEventMessageDeleted"] = "chatEventMessageDeleted";
    CHAT_EVENT_ACTION["chatEventPollStopped"] = "chatEventPollStopped";
    CHAT_EVENT_ACTION["chatEventMessagePinned"] = "chatEventMessagePinned";
    CHAT_EVENT_ACTION["chatEventMessageUnpinned"] = "chatEventMessageUnpinned";
    CHAT_EVENT_ACTION["chatEventMemberJoined"] = "chatEventMemberJoined";
    CHAT_EVENT_ACTION["chatEventMemberLeft"] = "chatEventMemberLeft";
    CHAT_EVENT_ACTION["chatEventMemberInvited"] = "chatEventMemberInvited";
    CHAT_EVENT_ACTION["chatEventMemberPromoted"] = "chatEventMemberPromoted";
    CHAT_EVENT_ACTION["chatEventMemberRestricted"] = "chatEventMemberRestricted";
    CHAT_EVENT_ACTION["chatEventTitleChanged"] = "chatEventTitleChanged";
    CHAT_EVENT_ACTION["chatEventPermissionsChanged"] = "chatEventPermissionsChanged";
    CHAT_EVENT_ACTION["chatEventDescriptionChanged"] = "chatEventDescriptionChanged";
    CHAT_EVENT_ACTION["chatEventUsernameChanged"] = "chatEventUsernameChanged";
    CHAT_EVENT_ACTION["chatEventPhotoChanged"] = "chatEventPhotoChanged";
    CHAT_EVENT_ACTION["chatEventInvitesToggled"] = "chatEventInvitesToggled";
    CHAT_EVENT_ACTION["chatEventSignMessagesToggled"] = "chatEventSignMessagesToggled";
    CHAT_EVENT_ACTION["chatEventStickerSetChanged"] = "chatEventStickerSetChanged";
    CHAT_EVENT_ACTION["chatEventIsAllHistoryAvailableToggled"] = "chatEventIsAllHistoryAvailableToggled";
})(CHAT_EVENT_ACTION = exports.CHAT_EVENT_ACTION || (exports.CHAT_EVENT_ACTION = {}));
